import {parseResponse} from './helpers/api'
import client from './client'
import axios from 'axios'

export default {
    async getInitialData() {
        return client.v1.get(`/get-initial-data`).then((response) => {
            return parseResponse(response)
        })
    },
    async getFile(id) {
        return client.common.get(`/files/get`, {
            params: {
                id: id
            },
            responseType: 'arraybuffer',
            headers: {
                'Accept': 'application/pdf'
            }
        }).then((response) => {
            return response.data
        })
    },
    async getFileFromSource(source) {
        return axios.get(source, {
            responseType: 'arraybuffer'
        }).then((response) => {
            return response.data
        })
    },
    async getEndPeriod(fromDatetime, days, daysType) {
        let response = null
        try {
            response = await client.common.get(`/calendar/get-end-period`, {
                params: {
                    fromDatetime: fromDatetime,
                    days: days,
                    daysType: daysType
                }
            })
        } catch (e) {
            response = e.response
        }

        return parseResponse(response)
    }
}